<template>
  <div v-if="isPaidUser" class="margin-bottom-12">
    <label>
      <span class="margin-right-8">
        <slot name="label">Logo</slot>
      </span>
      <tooltip-new class="is-inline-block" content-width="180px">
        Upload a PNG or JPEG file. The minimum or expected size is 211 x 54 px. Max file size is 10 MB.
      </tooltip-new>
    </label>

    <div class="margin-top-9">
      <img v-if="logoSrc" :src="logoSrc" class="photo-row-thumbnail"/>
      <span v-else class="photo-row-thumbnail">&nbsp;</span>
      <a @click.prevent="addLogo" class="blue-link font-size-12" href="#">
        Add Logo
      </a>
      <a v-if="logoPath" @click.prevent="removeLogo" class="blue-link font-size-12 margin-left-10" href="#">
        Remove
      </a>
    </div>
  </div>
</template>

<script>
import {misc} from '@/mixins'
import {TooltipNew} from '@/widgets'

export default {
  name: 'AddLogo',
  props: {
    logoPath: {
      type: String,
      default: ''
    },
    showDefaultLogo: {
      type: Boolean,
      default: true
    },
    group: {
      type: String
    },
    onClick: {
      type: Function
    },
    onRemove: {
      type: Function
    }
  },
  components: {
    TooltipNew
  },
  mixins: [misc],
  computed: {
    logoSrc () {
      if (this.logoPath) {
        return this.logoPath
      }

      if (this.showDefaultLogo) {
        return '/static/img/mailers/users/mailer-logo-hellopeter.png'
      }

      return ''
    }
  },
  methods: {
    addLogo () {
      if (this.onClick) {
        this.onClick()
      } else {
        window.events.$emit('add-logo', {
          action: 'add',
          group: this.group
        })
      }
    },
    removeLogo () {
      if (this.onRemove) {
        this.onRemove()
      } else {
        window.events.$emit('add-logo', {
          action: 'remove',
          group: this.group
        })
      }
    }
  }
}
</script>

<style scoped>
.photo-row-thumbnail {
  width: 40px;
  height: 40px;
  border: solid 1px #dbdbdb;
  background-color: #FFFFFF;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 6px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/AddLogo.vue